import PropTypes from "prop-types"
import React from "react"
import styled from "styled-components"

// ----------------------------------------------------------------------------

function _FullHeight(props) {
    // -------------------------------------
    // Props destructuring
    // -------------------------------------

    const { className, bgImage } = props

    // -------------------------------------
    // Hooks (e.g. useState, useMemo ...)
    // -------------------------------------

    // -------------------------------------
    // Effects
    // -------------------------------------

    // -------------------------------------
    // Component functions
    // -------------------------------------

    // -------------------------------------
    // Component local variables
    // -------------------------------------

    return <div className={`${className}`} style={{ backgroundImage: `url(${bgImage})` }}>{props.children}</div>
}

// ----------------------------------------------------------------------------
// Component PropTypes and default props
// ----------------------------------------------------------------------------

_FullHeight.propTypes = {
    className: PropTypes.string.isRequired,
}

_FullHeight.defaultProps = {}

// ----------------------------------------------------------------------------

const FullHeight = styled(_FullHeight)`
    & {
        position:relative;
        min-height: calc(
            100vh - ${(props) => props.theme.spacing.padding} * 2 -
                ${(props) => props.theme.font.logo.height}
        );
        background-size: cover;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        & > * {
            position: releative;
            z-index: 1;
        }
        ::before {
            content: "";
            position: absolute;
            top: 0; left: 0; right: 0; bottom: 0;
            background-color: ${(props) => props.theme.colors.trasparentBlackBg};
            z-index: 0;
        }
    }
`
// ----------------------------------------------------------------------------

export default FullHeight
